import BookTableRow from "../BookTableRow/BookTableRow";
import SortableHeader from "./SortableHeader";
import { bookExtractHeaders } from "./headers";
import type { Book, SortState } from "../BookExtracts/types";
import './BookTable.scss'

interface BookTableProps {
  books: Book[];
  sort: SortState | null;
  onSort: (key: string) => void;
}

function BookTable({ books, sort, onSort }: BookTableProps) {
  return (
    <table className="book-table">
      <thead>
        <tr>
          {bookExtractHeaders.map((header) => (
            <SortableHeader
              key={header.key}
              header={header}
              sort={sort}
              onSort={onSort}
            />
          ))}
        </tr>
      </thead>
      <tbody>
        {books.map((book, index) => (
          <BookTableRow book={book} index={index} key={book.isbn} />
        ))}
      </tbody>
    </table>
  );
}

export default BookTable;
